<template>
  <div>
    <div class="overview">
      <div>账户余额（元）</div>
      <div>{{ result.bankbalance }}</div>
    </div>

    <div class="list-container">
      <div class="list-fixed">
        <p class="list-box-col__title">项目</p>
        <p class="list-box-col__content" v-for="item in items" :key="item">{{ item }}</p>
      </div>
      <div class="list-scroll">
        <div class="list-scroll-wrap">
          <div class="list-box-col" v-for="DTO in result.fundPlanDTOS" :key="DTO.text">
            <p class="list-box-col__title">{{ DTO.text }}</p>
            <p class="list-box-col__content" v-for="amount in amounts" :key="amount" :class="amount == 'fundgap' ? 'font-warn' : ''">{{ numberFormat(DTO[amount],'#,##0.##') || 0 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: {},
      items: [
        "月均销售额",
        "本月实际销售额",
        "月均回款额",
        "月应收金额",
        "本月已收金额",
        "月均已付金额",
        "月应付金额",
        "本月已付金额",
        "月均毛利",
        "月均费用",
        "本月已支付费用",
        "资金缺口",
        "资金盈余"
      ],
      amounts: [
        "saleamount",
        "tsaleamount",
        "receivedamount",
        "aramount",
        "recamount",
        "avgapamount",
        "apamount",
        "payamount",
        "mlamount",
        "feeamount",
        "tfeeamount",
        "fundgap",
        "fundsurplus",
      ]
    }
  },
  mounted() {
    this.getFundPlan()
  },
  methods: {
    getFundPlan() {
      let me = this

      me.$ajax({
        url: "/api/money/fundplan/getFundPlan"
      }).then(function (res) {
        if (res.success) {
          me.result = res.data
        }
      });
    }
  }
}
</script>

<style scoped>
.overview {
  margin: 10px 0;
  background: var(--weui-BG);
  text-align: center;
  font-size: large;
  font-weight: bold;
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
}
.list-fixed {
  width: 128px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex-grow: 1;
  overflow-y: scroll;
}
.list-scroll-wrap {
  width: 160%;
  display: flex;
  justify-content: space-around;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.font-warn {
  color: red;
}
</style>